<template>
  <div class="messageDetail">
    <div class="title">
      <img class="pointer" :src="back" alt="" @click="$parent.closeDetail">
      {{detail.Subject}}
    </div>
    <div class="detail">
      <div class="detailContent">
        <!--      <div class="title">{{detail.name || 'qwerty'}}</div>-->
        <div class="body">{{detail.Body}}</div>
        <div class="end">
          <div>PGEbet</div>
          <div>{{detail.time}}</div>
        </div>
        <div class="bottomLogo">
          <img :src="logo" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/images/common/logo1.svg'
import back from '@/assets/images/common/back_circle.svg'
export default {
  name: 'messageDetail',
  props: ['detail'],
  data () {
    return {
      logo,
      back
    }
  }
}
</script>

<style lang="less" scoped>
  .messageDetail {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 38px 120px;
    background: #202020;
    border-radius: 0 6px 6px 0;
    .title {
      position: relative;
      font-size: 22px;
      line-height: 26px;
      color: #F6D9AA;
      font-weight: bold;
      margin-bottom: 30px;
      img {
        position: absolute;
        left: -40px;
      }
    }
    .detail {
      max-height: 456px;
      margin-top: 30px;
      padding-right: 10px;
      overflow: auto;
      .detailContent {
        padding: 30px;
        background: #3D3D3D;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
        border-radius: 6px;
        .subject {
          font-size: 24px;
          line-height: 28px;
          color: #F6D9AA;
          font-weight: bold;
          margin-bottom: 8px;
        }
        /*.title {
          font-size: 24px;
          line-height: 28px;
          color: #F6D9AA;
          font-weight: bold;
          margin-bottom: 8px;
        }
        .subject {
          font-size: 18px;
          line-height: 21px;
          color: #fff;
          font-weight: bold;
          margin-bottom: 20px;
        }*/
        .body, .end {
          font-size: 14px;
          line-height: 24px;
          color: #C4C4C4;
          margin-bottom: 30px;
        }
        .bottomLogo {
          text-align: right;
          img {
            width: 40px;
          }
        }
      }
      &::-webkit-scrollbar {
        width: 1px;
        height: 100%;
      }
      &::-webkit-scrollbar-track {
        width: 1px;
        height: 100%;
        background-color: transparent;
        border-radius: 33px;
      } /* 滚动条的滑轨背景颜色 */
      &::-webkit-scrollbar-thumb {
        width: 1px;
        border-radius: 33px;
        background-color: #F6D9AA;
      } /* 滑块颜色 */
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Message/Children/messageDetail.vue